import { View } from '@rbilabs/universal-components';

import LottieView from 'components/lottie-animations/lottie-view';
import { isNative } from 'utils/environment';

import animation from './confetti-fries.json';
import { useConfettiFriesAnimation } from './use-confetti-fries-animation';

const AnimationContainer = View.withConfig({
  width: 'full',
  height: '100%',
  position: 'absolute',
  // background: 'rgba(100,100,100,.2)',
  _web: {
    maxWidth: '600px',
    alignSelf: 'center',
  },
});

export const ConfettiFriesAnimation = () => {
  const { isAnimationComplete, setIsAnimationComplete } = useConfettiFriesAnimation();

  return (
    !isAnimationComplete && (
      <AnimationContainer>
        <LottieView
          autoPlay={true}
          loop={false}
          source={animation}
          style={
            isNative
              ? {
                  position: 'absolute',
                  alignSelf: 'center',
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  margin: -50,
                  pointerEvents: 'none',
                }
              : {}
          }
          webStyle={{}}
          onAnimationFinish={() => {
            // Add delay on Native to allow time for the animation to finish
            setTimeout(() => setIsAnimationComplete(true), isNative ? 2000 : 0);
          }}
        />
      </AnimationContainer>
    )
  );
};
